var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"zyzlogo1"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/图层 941.png")}})]),_vm._v(" "),_c('div',{staticClass:"zyzlogo2"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/图层 941.png")}}),_vm._v(" "),_c('img',{staticClass:"logo2",attrs:{"src":_vm.$store.getters.site.logo}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4c76664","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = null
// module chunks = 